import { Button, Col, Row } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from "react-router-dom"
import * as etiquetas from '../../ApplicationResources';
import HeaderModule from '../interfaz/Elements/HeaderModule';
import TemplateExterno from '../interfaz/TemplateExterno';
import iconEmail from '../../img/icons/Correo.svg';
import iconJDE from '../../img/icons/JDE.svg';
import { ReactSVG } from 'react-svg'
import { redireccionar } from '../../utils/funciones';
import imagenConvocatoria from '../../img/svg/Convocatoria.jpg';
import iconoDescargaPDF from '../../img/icons/descarga-pdf.jpg';
import convocatoriaAspirantes from '../../documentos/Convocatoria_Vigente.pdf';

class Convocatoria extends React.Component {
    constructor(props) {
        super(props);
    }

    redireccionarRegistroAspirante = () => {
        this.props.history.push('/registro_aspirante');
    }

    render() {
        return (
            <TemplateExterno enlaces={true}>
                <Row>
                    <Col >
                        <Row>
                            <Col sm={24} md={24} lg={24}>
                                <HeaderModule title="Convocatoria" />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={24} md={{span: 12, offset: 6}} lg={{span: 12, offset: 6}} className='convocatoria_imagen' >
                                <img src={imagenConvocatoria} />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={24} md={{ span: 10, offset: 3 }} lg={{ span: 8, offset: 5 }} className='convocatoria_columna_1' >
                                <span>
                                    <h3>Para más detalles de la convocatoria
                                        <Link to={convocatoriaAspirantes} target="_blank" rel="noopener noreferrer" className='link_guia_registro'>descarga el PDF</Link>
                                        <img src={iconoDescargaPDF} className='icono_megafono' />
                                    </h3>

                                </span>
                            </Col>
                            <Col sm={24} md={{ span: 3, offset: 1 }} lg={{ span: 2, offset: 1 }} className='convocatoria_columna_2' >
                                <Button type="primary"
                                    className="button_style"
                                    id="btn-sesion"
                                    onClick={this.redireccionarRegistroAspirante}>
                                    Registrate aquí
                                </Button>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </TemplateExterno>
        );
    }
};

export default withRouter(Convocatoria);